import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import { cityFragment } from './fragments';

export const CITY_SAVED = gql`
  subscription citySaved($id: Int) {
    citySaved(id: $id) {
      city {
        ...city
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${cityFragment}
`;

export const CITIES_DELETED = gql`
  subscription citiesDeleted {
    citiesDeleted {
      ids
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
